import React from "react";
import { MoreVertical, Settings, Plus } from "lucide-react";
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from "react-router-dom";

const HeaderMobile = ({ setShowMenu, showMenu, setShowConfirm }) => {
  const navigate = useNavigate();

  const login = () => {
    navigate("/login");
  };

  return (
    <div className="bg-slate-800 p-2 pt-safe-top border-b border-slate-700 flex items-center justify-between">
      <button onClick={() => navigate("/")}>
        <img
          src="/logoGeo.svg"
          alt="GeoPolitikIA logo."
          width={220}
          height={32}
        />
      </button>
      {/* Menu secondaire */}
      <div className="relative">
        <button
          onClick={() => setShowMenu(prev => !prev)}
          className="text-slate-300 hover:text-white p-2 rounded-md hover:bg-slate-700 transition"
        >
          <MoreVertical size={20} />
        </button>

        {showMenu && (
          <div className="absolute right-0 mt-2 w-32 bg-slate-700 text-slate-200 rounded-md shadow-lg py-1 z-50">
            <button
              onClick={login}
              className="w-full text-left px-4 py-2 hover:bg-slate-600 text-sm flex items-center gap-1"
            >
              <Settings size={14} />
              Config
            </button>
            <button
              onClick={() => setShowConfirm(true)}
              className="w-full text-left px-4 py-2 hover:bg-slate-600 text-sm flex items-center gap-1"
            >
              <Plus size={14} />
              New Game
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default HeaderMobile;
